module.exports = __webpack_public_path__ + "static/media/1065.c8e8b339.png";